import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from 'actions';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import {
  GeoJSON, parseAddress, getIconForClient,
  getImage, getIconForPlace, processPoints,
  convertContactToClient, setMapInstance
} from 'utils';

import {
  SidebarRight, PlaceDetails, StormReport,
  MapDetails, FeatureDetails, DownloadedMapList,
  ProgressBar, Slider, MarkerOptionsContainer,
  MarkerDetails, ClientCreate, Legend,
  ClientsOptions, DownloadContactsButton,
  ContactDetails, ContactMarker, ImpactMapList
} from 'components';
import {ClientDetails} from '../../client';
import classNames from 'classnames';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import OwlCarousel from 'react-owl-carousel';
import {
  Map, DataLayer, InfoWindow,
  Feature, MapControl, SearchBox,
  MarkerCluster, Marker, Circle,
  CustomOverlay, KmlLayer
} from 'google-react-maps';
import Select from 'react-select';
import { Modal, Row, Col } from 'react-bootstrap';
import CanvassingRegions from './canvassing-regions';
import * as Permissions from 'permissions';

const copy = obj => JSON.parse(JSON.stringify(obj));
const equalArrays = (arr1, arr2) => {
  if(arr1.length != arr2.length) {
    return false;
  }
  arr1.sort();
  arr2.sort();

  for(let i = 0; i < arr1.length; i++) {
    if(arr1[i] != arr2[i]) {
      return false;
    }
  }
  return true;
}

class ClientsMapView extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'ClientsMapView';

        this.handleMapClick = this.handleMapClick.bind(this);
        this.onClientClick = this.onClientClick.bind(this);
        this.closeSidebar = this.closeSidebar.bind(this);
        this.triggerNewClient = this.triggerNewClient.bind(this);
        this.handleSaveNewClient = this.handleSaveNewClient.bind(this);
        this.handleCancelNewClient = this.handleCancelNewClient.bind(this);
        this.handleBoundsChanged = this.handleBoundsChanged.bind(this);
        this.handleCenterChanged = this.handleCenterChanged.bind(this);
        this.centerOnCurrentLocation = this.centerOnCurrentLocation.bind(this);
        this.handleZoomChanged = this.handleZoomChanged.bind(this);
        this.handlePlacesChanged = this.handlePlacesChanged.bind(this);
        this.handleSearchMaps = this.handleSearchMaps.bind(this);
        this.handleFeatureClick = this.handleFeatureClick.bind(this);
        this.handleSwathFilter = this.handleSwathFilter.bind(this);
        this.triggerFindingMaps = this.triggerFindingMaps.bind(this);
        this.initUserLocation = this.initUserLocation.bind(this);
        this.toggleViewCurrentLocation = this.toggleViewCurrentLocation.bind(this);
        this.toggleShowOpacitySlider = this.toggleShowOpacitySlider.bind(this);
        this.handleFiltersChange = this.handleFiltersChange.bind(this);
        this.handleClickContact = this.handleClickContact.bind(this);
        this.generateInfoWindow = this.generateInfoWindow.bind(this);

        this.bounds_timer = null;
        this.center_timer = null;
        this.center_change_valid = true;  // Needed due to the fact that setCenter calls the onCenter_Changed
                                          //  event handler, causing infinite loop

        this.map = null;
        this.maps = null;

        this.current_location = null;
        this.current_location_marker = null;
        this.current_location_id = null;

        this.focus = this.focus.bind(this);
        this.center = localStorage ? (JSON.parse(localStorage.getItem('map_center'))) : undefined;
        let default_zoom =  localStorage ? (Number(localStorage.getItem('map_zoom'))) : undefined;

        this.state = {
          current_results : [],
          current_marker_id : null,
          marker_title : '',

          view_current_location : localStorage ? (localStorage.getItem('view_current_location') == 'true' || false) : false,
          contacts: [],
          client_id : null,
          canvassing : false,
          message : undefined,
          status : 'primary',

          query : '',
          storm_date : undefined,
          //Map controls
          search_center : {lat : 0, lng : 0},
          search_radius : 8046.72, //50 miles
          setting_search_radius: false,
          view_sales_regions: localStorage ? JSON.parse(localStorage.getItem('view_sales_regions') || 'false') : false,
          show_storm_reports : localStorage ? (localStorage.getItem('show_storm_reports') == 'true' || false) : false,
          show_places_search : true,
          show_opacity_slider : localStorage ? (localStorage.getItem('show_places_search') == 'false' ? false : true) : true,
          finding_maps : localStorage ? (localStorage.getItem('finding_maps') == "true" || false) : true,
          creating_client : localStorage ? (localStorage.getItem('creating_client') == "true" || false) : false,
          selected_feature : null,
          selected_map : null,
          bounds : localStorage ? (JSON.parse(localStorage.getItem('map_bounds'))) : null,
          zoom : isNaN(default_zoom) ? 14 : default_zoom,
          opacity : 30,
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return true;
    }
    initUserLocation(map, maps) {
      var {baseUrl, imagesPath} = this.props.connection;
      if (navigator.geolocation) {
        var icon = baseUrl + imagesPath + "client-icon.png";
        var marker = new maps.Marker({
          map,
          icon,
        });

        this.current_location_marker = marker;
        if(
          localStorage &&
          (localStorage.getItem('view_current_location') == 'false' || localStorage.getItem('view_current_location') == null)
        ) {
          this.current_location_marker.setMap(null)
        }

        var handlePos = position => {
          this.current_location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          marker.setPosition(this.current_location);
          if(this.current_location) {
            this.setState({ current_location: this.current_location });
            if(this.props.onUpdateCurrentLocation) {
              this.props.onUpdateCurrentLocation(current_location);
            }
          }
          if(this.state.view_current_location) {
            map.setCenter(this.current_location);
          }
        }
        navigator.geolocation.getCurrentPosition((position) => {
          handlePos(position);
          this.current_location_id = navigator.geolocation.watchPosition(handlePos, (err) => {console.log('err : ', err)}, {timeout : 1000, maximumAge: 60000});
        })
      } else {
        // Browser doesn't support Geolocation
        if(localStorage) {
          localStorage.setItem('view_current_location', 'false')
        }
        console.warn("This browser doesn't support geolocation.")
      }
    }
    toggleViewCurrentLocation() {
      if(this.current_location_marker) {
        if(!this.state.view_current_location) {
          this.setState({view_current_location : true})
          localStorage.setItem('view_current_location', 'true');
          this.current_location_marker.setMap(this.map)

          const handlePos = position => {
            this.current_location = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            this.current_location_marker.setPosition(this.current_location);
          }
          this.map.setCenter(this.current_location)
        }
        else {
          this.setState({view_current_location : false})
          localStorage.setItem('view_current_location', 'false');
          this.current_location_marker.setMap(null)
          navigator.geolocation.clearWatch(this.current_location_id)
        }
      }
    }
    toggleSalesRegions = () => {
      localStorage.setItem('view_sales_regions', JSON.stringify(!this.state.view_sales_regions));
      this.setState({
        view_sales_regions: !this.state.view_sales_regions
      });
    }
    toggleShowOpacitySlider() {
      this.setState({show_opacity_slider : !this.state.show_opacity_slider}, () => {
        if(localStorage) {
          let current_setting = localStorage.getItem('show_opacity_slider');
          localStorage.setItem('show_opacity_slider', this.state.show_opacity_slider ? 'true' : 'false')
        }
      })
    }
    triggerNewClient() {

      var address,
          name,
          phone;
      var {current_results} = this.state;
      let current_place = current_results[0]
      if(current_place)  {
          address = parseAddress(current_place);
          name = current_place.name ? current_place.name : '';
          phone = current_place.international_phone_number? current_place.international_phone_number : '';
          this.setState({newClient: true, client : {name, address, phone}, show_geocode_infowindow: false, })
      }
    }
    handleFiltersChange(value) {
      this.props.updateClientsFilters({ filters : value });
      this.props.clearClients();
      this.props.fetchClients();
    }
    handleSaveNewClient(client) {
        var _self = this;
        this.props.addClient(client, function(err,client) {
            _self.setState({newClient:false, client: {}});
        })
    }
    handleCancelNewClient() {
        this.setState({client:{},newClient:false});
    }
    handleMapClick(event, done) {
      let geocoder = this.refs.map.getGeocoder();
      let maps = this.refs.map.getGoogleMapsApi();
      let location = event.coords || event.latLng.toJSON();

      geocoder.geocode({location}, (results, status) => {
        if(status == maps.GeocoderStatus.OK) {
          this.closeSidebar();
          this.props.updateCurrentPlace(results[0])
          this.setState({places : [results[0]], search_center : location}, () => {
            if(done) done();
          });
        }
      })
    }
    handleBoundsChanged(bounds) {
      if(this.bounds_timer)
        clearTimeout(this.bounds_timer);

      if(localStorage) {
        localStorage.setItem('map_bounds', JSON.stringify(bounds))
      }

      this.bounds_timer = setTimeout(() => {
        this.setState({ bounds }, () => {
          this.props.updateClientsBounds(bounds);
          if(this.props.canvassing.canvassing) {
            this.props.fetchMarkers(bounds);
          }
        })

        //Refresh search.
        const {searchBox} = this.refs;

      }, 1000);
    }
    handleCenterChanged(center) {
      if(localStorage) {
        localStorage.setItem('map_center', JSON.stringify(center));

        if(localStorage.getItem('view_current_location') == 'true') {
          if(this.center_timer) {
            clearTimeout(this.center_timer)
          }
          //Suggestion
          //1. Create a function that starts and stops an interval.
          //2. In the interval, every 60 seconds call getCurrentPosition and setState with the coords
          //3. Set the map center to the state.center
          this.center_timer = setTimeout(() => {
            if(this.center_change_valid) {
              // navigator.geolocation.getCurrentPosition(() => {}, () => {}, {})
              navigator.geolocation.getCurrentPosition(this.centerOnCurrentLocation, e => {console.log('ERR : ', e)}, {enableHighAccuracy : true})
              this.center_change_valid = false;
            }
            else {
              this.center_change_valid = true;
            }
          }, 500)
        }
      }

      this.center = center;
    }
    handleClickContact(contact) {
      this.closeSidebar(f => {
        this.setState({ selected_contact : contact, selected_client_id: '' });
      });
    }
    generateInfoWindow(feature) {
      const { info_window_text, info_window_image_file } = feature.properties;
      if(!info_window_text && !info_window_image_file) {
        return null;
      }
      return (
        `<div class="panel">
          <div class="panel-body">
            ${info_window_text ? (
            `<div class="row">
              <div class="col-xs-12 col-md-12">
                <h5>${info_window_text}</h5>
              </div>
            </div>`
            ) : ''}
            ${info_window_image_file ? (
              `<div class="row">
                <div class="col-md-12 col-xs-12 map-creator-info-window-image">
                  <img src="${info_window_image_file.url}">
                </div>
              </div>`
            ) : ''}
          </div>
        </div>`
      );
    }
    centerOnCurrentLocation(pos) {

    }
    handleZoomChanged(zoom) {
      if(localStorage && zoom) {
        localStorage.setItem('map_zoom', zoom)
      }
      if(!zoom || zoom > 11) {
        return;
      }
    }
    handlePlacesChanged(places) {
      if(places.length == 1) {
        if(this.map && this.currently_selected_place != places[0].id) {
          this.currently_selected_place = places[0].id;
          this.map.setCenter(places[0].geometry.location);
        }
      }

      this.setState({places});
    }
    handleSwathFilter(feature, map) {
      this.props.addClientsFilter({
        coordinates : feature.geometry.coordinates,
        map: map._id,
        feature : feature._id,
        type : 'swath',
        value : [feature._id, map._id].join(','),
        label : `swath: ${feature.properties.hailSize}'' Hail - ${moment(map.properties.storm_date).format('MM/DD/YYYY')}`
      })
      this.props.clearClients();
      this.props.fetchClients();
    }
    onClientClick(id, latLng) {
      if (this.props.hasPermission('/Account Management/Clients/')) {
        this.closeSidebar(f => {
          let maps = this.refs.map.getGoogleMapsApi();
          let geocoder = this.refs.map.getGeocoder();
          geocoder.geocode({location: latLng}, (results, status) => {
            if(status == maps.GeocoderStatus.OK) {
              this.props.updateCurrentPlace(results[0])
              this.setState({ search_center: latLng });
            }
          });

          if (this.props.clients.selected_client_id) {
            this.props.leaveSocketChannel(this.props.clients.selected_client_id);
          }
          this.props.selectClient(id);
          this.props.joinSocketChannel(id);
        });

      }
    }
    closeSidebar(done) {
      this.props.selectClient(null);
      this.props.updateCurrentPlace(null)
      this.setState({storm_report : null, search_center : {}, selected_feature : null, current_marker_id : null, selected_contact: undefined }, done? done : f => {});
      this.props.leaveSocketChannel(this.props.clients.selected_client_id);
    }
    triggerCreateClient() {
      this.setState({creating_client : true});
    }
    triggerFindingMaps() {
      this.setState({finding_maps : !this.state.finding_maps});
      if(localStorage) {
        localStorage.setItem('finding_maps', !this.state.finding_maps);
      }
    }
    toggleStormReports() {
      if(this.state.show_storm_reports) {
        this.props.updateStormData(null); //Clear out storm data.
      }

      this.setState({show_storm_reports : !this.state.show_storm_reports});
      if(localStorage) {
        localStorage.setItem('show_storm_reports', !this.state.show_storm_reports);
      }
    }
    toggleSearch() {
      if(localStorage) {
        localStorage.setItem('show_places_search', !this.state.show_places_search);
      }
      this.setState({show_places_search : !this.state.show_places_search});
    }
    handleSearchMaps() {
      const {
        lat, lng
      } = this.state.search_center;

      this.props.findMaps({
        coordinates : [lng,lat],
        radius : this.state.search_radius
      });
      this.props.showFoundMaps();
      this.triggerFindingMaps();
    }
    handleFeatureClick(feature, item) {
      this.setState({
        selected_feature : {...feature.geoJson},
        selected_map : item.id
      });
    }
    componentWillMount() {
      //Force the body to be fixed.
      $('html, body').css({ position: 'fixed' });
      this.props.hideFoundMaps();
      if(
        this.props.hasPermission('/Canvassing/Markers/Manage/') &&
        this.props.route.path == 'canvassing'
      ) {
        this.props.initMapMarkerTypes();
        this.props.toggleCanvassing(true);
      }
      if(localStorage && localStorage.getItem('view_current_location') == null) {
        localStorage.setItem('view_current_location', 'true')
      }
      this.setState({ view_current_location : (localStorage && localStorage.getItem('view_current_location') == 'true') });
      this.props.toggleViewingClientsMap(true);
    }
    componentDidMount() {
      const { props } = this;
      // If the map is set as a param, download it and focus on it.
      if(props.params.mapID) {
        setTimeout( f => props.downloadMap(props.params.mapID, (err, map) => {
          this.maps.event.trigger(this.map,'resize');
          this.focus(map, true);
        }), 1000);
      }
    }
    componentDidUpdate(prevProps, prevState) {
      if(this.props.params.mapID != prevProps.params.mapID && this.props.params.mapID) {
        this.props.downloadMap(this.props.params.mapID, (err, map) => this.focus(map))
      }

      if(this.props.clients.selected_client_id && prevProps.clients.selected_client_id != this.props.clients.selected_client_id) {
        this.props.fetchClient(this.props.clients.selected_client_id);
      }
      if(this.maps && this.map) {
        this.maps.event.trigger(this.map,'resize');
      }
      if(!prevProps.canvassing.canvassing && this.props.canvassing.canvassing && this.state.bounds) {
        this.props.fetchMarkers(this.state.bounds);

        if(!this.props.canvassing.marker_types_initialized) {
          this.props.initMapMarkerTypes();
        }
      }
      if(
        this.props.canvassing.canvassing &&
        !equalArrays(prevProps.canvassing.filtered_marker_types, this.props.canvassing.filtered_marker_types)
      ) {
        this.props.fetchMarkers(this.state.bounds);
      }
      if(this.props.canvassing.canvassing && prevProps.canvassing.filter_user !== this.props.canvassing.filter_user) {
        this.props.fetchMarkers(this.state.bounds);
      }
    }
    componentWillUnmount() {
      //Stop forcing the body to be fixed.
      $('html, body').css({ position: '' });

      //Clear out storm data.
      this.props.updateClientsBounds(null);
      this.props.updateStormData(null);
      this.props.updateCurrentPlace(null);
      this.props.toggleViewingClientsMap(false);
    }
    focus(geoJson, shouldZoom) {
      if(this.map) {
        var maps = this.maps;
        var map = this.map;
        if(map && maps) {

          var bounds = new maps.LatLngBounds();
          var processFeature = (feature) => {
            var getLatLng = (coords) => {
              return new maps.LatLng({
                lng : coords[0],
                lat : coords[1]
              })
            }
            var processArray = (array) => {
              array.forEach(item => {
                if(item[0] instanceof Array) {
                  processArray(item);
                }
                else {
                  bounds.extend(getLatLng(item));
                }
              })
            }
            if(feature.geometry) {
              switch(feature.geometry.type) {
                case 'Polygon': {
                  processArray(feature.geometry.coordinates);
                  break;
                }
                case 'Point': {
                  bounds.extend(getLatLng(feature.geometry.coordinates));
                  break;
                }
                default: {
                  console.log('Invalid feature supplied to focus()');
                }
              }
            }
          }

          if(geoJson) {
            switch(geoJson.type) {
              case "FeatureCollection":
                geoJson.features.forEach(processFeature);
              case "Feature":
                processFeature(geoJson);
            }
            // Only zooms on mount
            if(shouldZoom) {
              map.fitBounds(bounds);
            }
          }
        }
      }
    }

    render() {
      const _self = this;

      const {
        show_geocode_infowindow,
        geocode_results,
        infowindow_coords,
        current_results,
        search_radius,
        search_center,
        setting_search_radius,
        show_places_search,
        view_sales_regions,
        contacts,
        selected_contact,
        finding_maps,
        zoom,
      } = this.state;

      const {
        clients,
        maps,
        map_search,
        canvassing,
        routing
      } = this.props;

      const { filters, selected_filters } = clients;

      const {
        found_maps,
        downloaded_maps,
        show_downloaded_maps,
        show_found_maps,
      } = map_search;
      const current_marker = canvassing.markers.find(({_id}) => _id == this.state.current_marker_id);
      let current_result = current_results[0];

      const {stormData} = maps;
      const {wind, hail, tornado} = stormData || {};

      const InfoControl = (
        <MapControl position="RIGHT_CENTER">
          {this.state.message ? (
            <div className="col-xs-12">
              <div className={`alert alert-${this.state.status} fade in`}>
                <button onClick={e => this.setState({message:""})} className="close">x</button>
                <p>{this.state.message}</p>
              </div>
            </div>
          ) : ('')}
        </MapControl>
      )
      const SearchControlWrapper = ({children}) => (
        <div style={{maxWidth:"300px",width:"100%"}} className="mb-sm">
          <div className="input-group">
            <span className="input-group-addon"><i className="wi-compass"></i> </span>{children}
          </div>
        </div>
      );

      let controls = [];

      const DownloadedMaps = (
        <MapControl position="RIGHT_CENTER">
          <DownloadedMapList
            onMapClick={item => {this.focus(item.map)}}
            onMapZoom={item => {this.focus(item.map, true)}}
          />
        </MapControl>
      )
      const SearchControl = (
        <SearchBox
          ref="searchBox"
          placeholder="Enter a place name, address, or type"
          onPlacesChanged={this.handlePlacesChanged}
          wrapper={SearchControlWrapper}
          className="form-control"
          position="BOTTOM_CENTER"
        />
      )
      const OpacityControl = (
        <MapControl position="LEFT_CENTER">
          <div className={`swath-opacity-control ${classNames({'hidden-map-control' : !this.state.show_opacity_slider})}`}>
            <Slider
              percent={this.state.opacity * 100}
              onChange={value => this.setState({opacity : value})}
              height={`100px`} percent={30}
            />
          </div>
        </MapControl>
      )
      const SearchToggleControl = (
        <MapControl position="LEFT_BOTTOM">
          <div
            style={{marginLeft : '12px'}}
            onClick={this.toggleSearch.bind(this)}
            className={'btn btn-default btn-control places-search-control ' + classNames({
              'btn-primary' : this.state.show_places_search,
              'hidden-map-control' : this.state.show_opacity_slider
            })}
            >
            <span className="info animated fadeInLeft">Search Places</span> <i className="wi-compass"></i>
          </div>
        </MapControl>
      )
      const SearchMapsControl = (
        <MapControl position="LEFT_BOTTOM">
          <div
            style={{marginLeft : '12px'}}
            onClick={this.triggerFindingMaps.bind(this)}
            className={"btn btn-default btn-control map-search-control " + classNames({
              'btn-primary' : this.state.finding_maps,
              'hidden-map-control' : this.state.show_opacity_slider
            })}>
            <span className="info animated fadeInLeft">Find Maps</span> <i className="fa fa-map"></i>
          </div>
        </MapControl>
      )
      const toggleKMLLayersControl = (
        <MapControl position='LEFT_BOTTOM'>
          <div
            style={{marginLeft : '12px'}}
            onClick={e => this.setState({ display_kml: !this.state.display_kml })}
            className={"btn btn-default btn-control current-location-control " + classNames({
              'btn-primary' : this.state.display_kml,
              'hidden-map-control' : this.state.show_opacity_slider
            })}>
            <span className="info animated fadeInLeft">Extra  Map Data</span>
            {' '}<i className="fa fa-map-signs"></i>
          </div>
        </MapControl>
      )
      const toggleViewCurrentLocationControl = (
        <MapControl position='LEFT_BOTTOM'>
          <div
            style={{marginLeft : '12px'}}
            onClick={this.toggleViewCurrentLocation}
            className={"btn btn-default btn-control current-location-control " + classNames({
              'btn-primary' : this.state.view_current_location,
              'hidden-map-control' : this.state.show_opacity_slider
            })}>
            <span className="info animated fadeInLeft">View Current Location </span>
            {' '}<i className="fa fa-location-arrow"></i>
          </div>
        </MapControl>
      )
      const toggleSalesRegions = (
        <MapControl position='LEFT_BOTTOM'>
          <div
            style={{marginLeft : '12px'}}
            onClick={this.toggleSalesRegions}
            className={"btn btn-default btn-control current-location-control " + classNames({
              'btn-primary' : this.state.view_sales_regions,
              'hidden-map-control' : this.state.show_opacity_slider
            })}>
            <span className="info animated fadeInLeft">View Sales Regions</span>
            {' '}<i className="fa fa-money"></i>
          </div>
        </MapControl>
      )
      const ToggleStormReportsControl = (
        <MapControl position="LEFT_BOTTOM">
          <div
            style={{marginLeft : '12px'}}
            onClick={this.toggleStormReports.bind(this)}
            className={"btn btn-default btn-control storm-reports-control " + classNames({
              'btn-primary' : this.state.show_storm_reports,
              'hidden-map-control' : this.state.show_opacity_slider
            })}>
            <span className="info animated fadeInLeft">Show Storm Reports</span> <i className="fa fa-map-marker"></i>
          </div>
        </MapControl>
      )
      const toggleShowOpacitySliderControl = (
        <MapControl position="LEFT_BOTTOM">
          <div
            style={{marginLeft : '12px'}}
            onClick={this.toggleShowOpacitySlider}
            className={'btn btn-default btn-control opacity-slider-control ' + classNames({
              'btn-primary' : this.state.show_opacity_slider,
            })}
            >
            <span className="info animated fadeInLeft">Show Swath Opacity Range</span> <i className="fa fa-sliders"></i>
          </div>
        </MapControl>
      )
      const StormDatePicker = (
        <MapControl position='TOP_CENTER'>
          <div className='mt-sm ml-md'>
            <DatetimeRangePicker
              singleDatePicker
              showDropdowns
              startDate={this.state.storm_date || moment()}
              onApply={(e, {startDate}) => {
                this.props.getStormData(moment(startDate, 'YYYY-MM-DD').format('MMDDYY'));
                this.setState({storm_date : startDate})
              }}
              >
              <Button className='selected-date-range-btn'>
                <div className='pull-left'>
                  Storm Reports{' '}
                  <i className='fa fa-calendar'/>
                  {' '}
                </div>
                <div className='pull-right'>
                  <i className='fa fa-angle-down'/>
                </div>
              </Button>
            </DatetimeRangePicker>
          </div>
        </MapControl>
      );
      const MapLegendControl = (
        <MapControl position='TOP_RIGHT'>
          <div className='custom-map-legend mt-sm mr-sm'>
            <Legend />
          </div>
        </MapControl>
      )
      const MapPrintControl = (
        <MapControl position="RIGHT_BOTTOM">
          <div style={{marginRight : "13px", padding: "3px 6px"}} onClick={function() {
            setTimeout(window.print, 100);
          }} className="btn btn-info"><i className="fa fa-print"></i></div>
        </MapControl>
      )

      //Push controls.
      controls.push(OpacityControl);
      controls.push(toggleShowOpacitySliderControl);
      controls.push(toggleKMLLayersControl);
      controls.push(SearchToggleControl);

      if(this.props.hasPermission(Permissions.VIEW_CANVASSING_REGIONS)) {
        controls.push(toggleSalesRegions);
      }

      controls.push(MapPrintControl);
      // controls.push(SearchMapsControl);
      controls.push(ToggleStormReportsControl);
      if(navigator.geolocation) {
        controls.push(toggleViewCurrentLocationControl)
      }
      controls.push(DownloadedMaps);

      if(this.state.show_places_search) {
        controls.push(SearchControl);
      }

      if(this.state.show_storm_reports) {
        controls.push(StormDatePicker);
      }
      controls.push(MapLegendControl);

        return (
          <div className="clients-map-view">
            <Map
              onCenter_Changed={this.handleCenterChanged}
              onZoom_Changed={this.handleZoomChanged}
              onbounds_changed={this.handleBoundsChanged}
              onMount={(map, maps) => {
                setMapInstance(map);
                this.map = map;
                this.maps = maps;
                try {
                  setTimeout(f => {
                    try {
                      this.initUserLocation(map,maps);
                    }
                    catch(ex) {
                      console.log(ex)
                    }
                  }, 1000)
                }
                catch(ex) {
                  console.log(ex)
                }
              }}
              center={this.center}
              ref='map'
              api-key="AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw"
              optionsConstructor={function(maps) {
                Object.assign(this, {
                  zoom : zoom || 4,
                  mapTypeId : maps.MapTypeId.ROADMAP,
                  disableDefaultUI: true,
                  zoomControl : true,
                  zoomControlOptions : {
                      position: maps.ControlPosition.LEFT_CENTER
                  },
                  keyboardShortcuts : true,
                  panControl: true,
                  panControlOptions : {
                      position : maps.ControlPosition.BOTTOM_RIGHT
                  },
                  mapTypeId : maps.MapTypeId.HYBRID,
                  mapTypeControl : true,
                  mapTypeControlOptions : {
                      position: maps.ControlPosition.BOTTOM_LEFT
                  },
                  fullscreenControlOptions : {
                      position: maps.ControlPosition.BOTTOM_LEFT
                  },
                  fullscreenControl: true
                });
              }}
              onClick={this.handleMapClick}
              onRightClick={this.handleMapClick}
              controls={controls}
              style={{position:"absolute", top: 0, right: 0, left: 0, bottom : 0, width : "100%"}}
              >
                {this.props.hasPermission(Permissions.VIEW_CANVASSING_REGIONS) && view_sales_regions ? <CanvassingRegions fillOpacity={this.state.opacity / 100} /> : null}
              {finding_maps ? (
                <Circle
                  editable={true}
                  radius={search_radius}
                  center={{...search_center}}
                  onRadiusChange={radius => {
                    if(!(radius <= 200 * 1609.344)) {
                        radius = 200 *1609.344;
                        if(radius < 0)
                            radius = 0;
                        displayNotice({message : "You cannot search more than 200 miles."}, {type : 'error', style:'danger', position:'stack-top-bar'});
                    }
                    this.setState({search_radius : radius});
                  }}
                  onCenterChange={coords => {
                    if(Number.isNaN(coords.lat) || Number.isNaN(coords.lng)) {
                      return;
                    }

                    if(coords.lat != search_center.lat || coords.lng != search_center.lng) {
                      this.setState({search_center : coords});
                    }
                  }}
                  onClick={this.handleMapClick}
                />
              ) : ('')}
              {downloaded_maps? [
                ...downloaded_maps.map(item => item.visible && this.state.display_kml ? (
                  (item.map.properties.kml_layers || []).map((file, idx) => <KmlLayer url={file.url} preserveViewport={true} zIndex={idx} />)
                ): []).reduce((a,b) => [...a,...b], []),
                ...downloaded_maps.map( (item, i) =>
                    item.visible ? (
                      <DataLayer
                        key={item.id}
                        zIndex={(item.map.properties.kml_layers || []).length + i + 1}
                        onClick={e => console.log(e.id, "clicked")}
                        fillOpacity={this.state.opacity / 100}
                        >
                        {item.map.features.map( (f,i) => {
                          let geoJson;
                          if(this.state.selected_feature && f._id == this.state.selected_feature._id) {
                            geoJson = {
                              ...f,
                              properties : {
                                ...f.properties,
                                strokeColor : '#000000'
                              }
                            };
                          }
                          else {
                            geoJson = f;
                          }

                          if(this.state.display_kml) {
                            return <div />
                          }
                          else {
                            switch(f.geometry.type) {
                              case 'Polygon': {
                                return (
                                  <Feature
                                    key={f._id ? f._id : f.properties._id}
                                    onRightClick={feature => {
                                      this.closeSidebar(f => {
                                        this.handleFeatureClick(feature, item);
                                      })
                                    }}
                                    onClick={this.handleMapClick}
                                    editable={false}
                                    id={f._id? f._id : f.properties._id}
                                    geoJson={geoJson}
                                  />
                                )
                              }
                              case 'Point': {
                                return item.markers_visible ? (
                                  <Feature
                                    key={f._id ? f._id : f.properties._id}
                                    onRightClick={feature => {
                                      this.closeSidebar(f => {
                                        this.handleFeatureClick(feature, item);
                                      })
                                    }}
                                    infoWindow={this.generateInfoWindow(f)}
                                    editable={false}
                                    id={f._id? f._id : f.properties._id}
                                    geoJson={geoJson}
                                    icon={f.properties.icon_file.url}
                                  />
                                ) : <noscript />;
                              }
                            }
                          }
                        }
                      )}
                    </DataLayer>
                  ) : ""
                )
              ] : ""}
              {this.state.places ?
                this.state.places.filter(place => {
                  if(!current_marker) {
                    return true;
                  }
                  else {
                    return place.place_id == current_marker.place
                  }
                }).map((place, index) => {
                    const coords = place.geometry.location.toJSON();
                    return (
                      <Marker
                        key={place.place_id}
                        onClick={f => {
                          this.closeSidebar(f => {
                            this.props.updateCurrentPlace(place)
                            this.setState({ selected_contact: undefined, search_center: coords });
                            this.props.selectClient(null);
                          })
                        }}
                        options={{
                          icon : {
                            url: getIconForPlace(place),
                            scaledSize: this.maps? new this.maps.Size(26.25,40.625) : undefined
                          }
                        }}
                        coords={coords}
                      />
                    )
                  }) :
                  () => {}}
                  {contacts.map(( contact, idx ) => {
                    return (
                      <ContactMarker
                        key={`${contact.uuid}-${idx}`}
                        onClick={f => this.handleClickContact(contact)}
                        contact={contact}
                        onChangeContact={updatedContact => this.setState({ contacts: [...contacts.slice(0,idx), updatedContact, ...contacts.slice(idx+1, contacts.length)] })}
                        options={{
                          icon: {
                            url: getImage('icon-person-alt.png'),
                            scaledSize: this.maps? new this.maps.Size(50,50) : undefined
                          }
                        }}
                      />
                    )
                  })}
              <MarkerCluster options={{ gridSize: 50, maxZoom: 15 }}>
                {clients.clients_map_list.map((client, index) => {
                  if(client.address && client.address.geocoded) {
                    let lng = client.address.feature.geometry.coordinates[0];
                    let lat = client.address.feature.geometry.coordinates[1];
                    return (
                      <Marker
                        key={client._id}
                        onClick={f => this.onClientClick(client._id, {lat,lng})}
                        options={{
                          icon: {
                            url: client._id != this.props.clients.selected_client_id ? getImage('default-home-icon.png') : getImage('default-home-icon-selected.png'),
                            scaledSize: this.maps? new this.maps.Size(50,50) : undefined
                          }
                        }}
                        coords={{lat,lng}}
                      />
                    )
                  }
                  else
                    return () => {}
                })}
                {canvassing.marker_types_initialized ? canvassing.markers.map(marker => {
                  let icon;

                  switch(marker.type) {
                    case 'Go Back':
                      icon = getImage('default-home-1.png');
                      break;
                    case 'Callback':
                      icon = getImage('default-home-2.png');
                      break;
                    case 'Not Home':
                      icon = getImage('default-home-3.png');
                      break;
                    case 'Not Interested':
                      icon = getImage('default-home-4.png');
                      break;
                    case 'Other':
                      icon = getImage('default-home-5.png');
                      break;
                    default :
                      let current_marker_type = canvassing.marker_types.find(mt => mt.key == marker.type)
                      if(current_marker_type) {
                        let {baseUrl, imagesPath} = this.props.connection;
                        icon = getImage(current_marker_type.url);
                      }
                  }

                  let lat = marker.location.coordinates[1];
                  let lng = marker.location.coordinates[0];
                  if(!this.maps) {
                    console.warn('Google Maps not initialized.')
                    return null;
                  }
                  return (
                    <Marker
                      key={marker._id}
                      onClick={event => {
                        this.closeSidebar(f => {
                          this.handleMapClick(event, f => this.setState({current_marker_id : marker._id}));
                        })
                      }}
                      coords={{lat, lng}}
                      opacity={marker.last_hit_timestamps && marker.last_hit_timestamps.length > 0 ? 0.65 : 1}
                      options={{
                        icon: icon ? {
                          url: icon,
                          scaledSize: this.maps? new this.maps.Size(26.25,40.625) : undefined
                        } : null,
                        ...(
                         marker.door_knock_number ? ({
                           labelContent: `${ marker.door_knock_number }`,
                           labelAnchor: new this.maps.Point(-8, 45),
                           labelClass: 'canvassing-marker-label',
                           labelInBackground: false
                         }) : ({})
                        )
                      }}
                    />
                  )
                }).filter(e => e) : []}
              </MarkerCluster>
              {(()=>{
                if(this.state.show_storm_reports) {
                  return (
                  <MarkerCluster options={{ gridSize : 50, maxZoom: 5 }} >
                      {wind ? wind.filter(item => ( !isNaN(Number(item.Lat)) && !isNaN(Number(item.Lon)) )).map(item => {
                        const coords = {lat : Number(item.Lat), lng : Number(item.Lon)}
                        return <Marker key={`${item.Lat}-${item.Lon}-sr`} onClick={f => {
                          this.closeSidebar(f => {
                            this.setState({storm_report : item, search_center : coords})
                          });

                        }} coords={coords} icon={{
                          url: getImage('wind-marker.png'),
                          scaledSize: this.maps? new this.maps.Size(50,50) : undefined
                        }} />
                      }) : f => {/* Necessary to avoid errors. */}}
                      {hail ? hail.filter(item => ( !isNaN(Number(item.Lat)) && !isNaN(Number(item.Lon)) )).map(item => {
                        const coords = {lat : Number(item.Lat), lng : Number(item.Lon)}
                        return <Marker key={`${item.Lat}-${item.Lon}-sr`} onClick={f => {
                          this.closeSidebar(f => {
                            this.setState({storm_report : item, search_center : coords})
                          });
                        }} coords={coords} icon={{
                          url: getImage('hail-marker.png'),
                          scaledSize: this.maps? new this.maps.Size(50,50) : undefined
                        }} />
                      }) : f => {}}
                      {tornado ? tornado.filter(item => ( !isNaN(Number(item.Lat)) && !isNaN(Number(item.Lon)) )).map(item => {
                        const coords = {lat : Number(item.Lat), lng : Number(item.Lon)}
                        return <Marker key={`${item.Lat}-${item.Lon}-sr`} onClick={f => {
                          this.closeSidebar(f => {
                            this.setState({storm_report : item, search_center : coords})
                          });
                        }} coords={coords} icon={{
                          url: getImage('tornado-marker.png'),
                          scaledSize: this.maps? new this.maps.Size(50,50) : undefined
                        }} />
                      }) : f => {}}
                  </MarkerCluster>
                  );
                }
              })()}
            </Map>
            <Modal bsSize="large" bsStyle="primary" show={show_found_maps} onHide={e => this.props.hideFoundMaps()}>
              <Modal.Header>
                <Modal.Title className="heading-title">Found Maps</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  {found_maps.map(map => (
                    <Col xs={12} md={4} style={{minHeight: "600px"}}>
                      <MapDetails map={map} />
                    </Col>
                  ))}
                  {found_maps.length == 0 ? (
                    <div className="col-xs-12">
                      <div className="text-center">No maps found.</div>
                    </div>
                  ) : ''}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div onClick={e => this.props.hideFoundMaps()} className="btn btn-default pull-right">Close</div>
              </Modal.Footer>
            </Modal>
            <SidebarRight
              open={
                (this.state.selected_feature) ||
                (this.props.clients.selected_client_id ? true : false) ||
                (this.props.clients.current_place ? true : false) ||
                (this.state.storm_report ? true : false) ||
                (this.state.selected_contact? true: false)
              }
              onClose={e => this.closeSidebar()}
              >
              {this.state.selected_feature ? <FeatureDetails
                className="mt-lg"
                feature={this.state.selected_feature}
                downloaded_map={downloaded_maps.find(({id}) => this.state.selected_map == id)}
                onFilter={this.handleSwathFilter}
              /> : null}
              {(()=>{
                if(this.state.selected_contact) {
                  return (
                    <ContactDetails
                      contact={this.state.selected_contact}
                      >
                      <ImpactMapList onViewMap={e => this.closeSidebar()} coords={{ lat: this.state.selected_contact.address.feature.geometry.coordinates[1], lng: this.state.selected_contact.address.feature.geometry.coordinates[0]}} />
                      <Button bsStyle={'dark'} onClick={f => this.props.startCreatingClient(convertContactToClient(this.state.selected_contact))}><i className="fa fa-plus"></i> Create Lead</Button>
                    </ContactDetails>
                  )
                }

                if(this.props.clients.selected_client_id && this.props.client._id) {

                  let {current_place} = this.props.clients;
                  return (
                    <div>
                      <ClientDetails onViewMap={e => this.closeSidebar()} client={this.props.client}>
                        <div>
                          <a className='pull-right clearfix' href='#' onClick={e => {
                            e.preventDefault();
                            this.setState({ client_details_show_contact: !this.state.client_details_show_contact });
                          }}>{this.state.client_details_show_contact && 'Hide More' || 'Show More'}</a>
                        </div>
                        <hr />
                        {current_place && current_place.address_components && this.state.client_details_show_contact ? (
                          <ContactDetails
                            place={current_place}
                            place_details={
                              <PlaceDetails
                                maps={this.maps}
                                map={this.map}
                                place={current_place}
                                onUpdatePlace={place => {this.props.updateCurrentPlace(place)}}
                                onCreateClient={() => this.props.startCreatingClient({address : parseAddress(current_place)})}
                              ></PlaceDetails>
                            }
                            render_buttons={props => (
                              <Button bsStyle={'dark'} onClick={e => this.props.startCreatingClient({ ...props.contact, address: parseAddress(props.place) })}><i className="fa fa-plus"></i> Create Lead</Button>
                            )}
                          ></ContactDetails>
                        ) : null}
                        <div className="row mb-lg">
                          <div className='col-xs-12 mb-xs'>
                            <div onClick={this.props.startCreatingJob} className="btn btn-dark btn-block"><i className="fa fa-handshake-o"></i> Create Opportunity</div>
                          </div>
                          <div className="col-xs-12">
                            <Link to={`client/${this.props.clients.selected_client_id}`} className="btn btn-primary btn-block"><i className="fa fa-user"></i> Manage Client</Link>
                          </div>
                        </div>
                      </ClientDetails>
                    </div>
                  )
                }

                if(this.props.clients.current_place) {
                  let {current_place} = this.props.clients;
                  return (
                    <div>
                      {canvassing.canvassing && !this.state.current_marker_id? (
                        <div>
                          <MarkerOptionsContainer place={current_place} current_location={this.state.current_location} />
                          <hr />
                        </div>
                      ) : ''}

                      {current_marker ? (
                        <div>
                          <MarkerDetails marker={this.state.current_marker_id} current_location={this.state.current_location} />
                          <hr className="text-muted"/>
                        </div>
                      ) : ''}
                      {this.props.show_create_client ? (
                        <ClientCreate
                          title="Create Lead"
                          client={{address : parseAddress(current_place)}}
                          onCancel={this.props.stopCreatingClient}
                          onSave={this.props.addClient}
                          modal
                        />
                      ) : null}
                        <ContactDetails
                          place={current_place}
                          place_details={
                            <PlaceDetails
                              maps={this.maps}
                              map={this.map}
                              place={current_place}
                              onUpdatePlace={place => {this.props.updateCurrentPlace(place)}}
                              onCreateClient={() => this.props.startCreatingClient({address : parseAddress(current_place)})}
                            >
                              <div>
                                <hr className="mb-sm mt-sm" />
                                <ImpactMapList onViewMap={e => this.closeSidebar()} coords={{ lat: current_place.geometry.location.lat(), lng: current_place.geometry.location.lng()}} />
                              </div>
                            </PlaceDetails>
                          }
                          render_buttons={props => (
                            <Button bsStyle={'dark'} onClick={e => this.props.startCreatingClient({ ...props.contact, address: parseAddress(props.place) })}><i className="fa fa-plus"></i> Create Lead</Button>
                          )}
                        >
                          <div>
                            <hr className="mb-sm mt-sm" />
                            <ImpactMapList details={'List of maps impacting this contact:'} onViewMap={e => this.closeSidebar()} coords={{ lat: current_place.geometry.location.lat(), lng: current_place.geometry.location.lng()}} />
                          </div>
                        </ContactDetails>
                    </div>
                  );
                }
                if(this.state.storm_report) {
                  return <StormReport report={this.state.storm_report} />
                }
              })()}
              <hr className="dotted short" />
              {this.state.search_center.lat && this.state.search_center.lng ? (
                <div className="row mb-sm">
                  <div className="col-xs-12 mb-sm">
                    {!finding_maps ? <div onClick={this.triggerFindingMaps} className="animated fadeInUp btn btn-dark btn-block"><i className="fa fa-map"></i> Nearby Maps</div> :
                      <Row>
                        <Col xs={8}>
                          <div onClick={this.handleSearchMaps} className="animated fadeInLeft btn btn-block btn-success"><i className="fa fa-search"></i> Search</div>
                        </Col>
                        <Col xs={4}>
                          <div onClick={this.triggerFindingMaps} className="animated fadeInRight btn btn-block btn-default">Cancel</div>
                        </Col>
                      </Row>
                    }
                  </div>
                  <Col xs={12}>
                    <DownloadContactsButton
                        onError={error => this.props.notify(error)}
                        onDownload={contacts => this.setState({ contacts })}
                        coords={[this.state.search_center.lng, this.state.search_center.lat]}
                        block
                        bsStyle={'dark'}
                      />
                  </Col>
                </div>
              ) : ''}

            </SidebarRight>
          </div>
        );
    }
}

const mapStateToProps = ({connection, clients, maps, client, map_search, canvassing, routing}) => ({connection, clients, maps, client, map_search, canvassing, routing});

export default connect(mapStateToProps, Actions)(ClientsMapView);



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/clients-map-view.js